import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

const AudioReviewDialog = ({
  open,
  onClose,
  onReRecord,
  onUpload,
  audioUrl,
  audioName,
  title,
  hintText,
  reRecordLabel,
  cancelLabel,
  uploadLabel,
  uploadDisabled = false,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    fullWidth
    maxWidth="sm"
  >
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <Typography variant="body2" sx={{ color: '#4a4a4a', mb: 2 }}>
        {hintText}
      </Typography>
      {audioUrl && (
        <Box
          component="audio"
          controls
          src={audioUrl}
          sx={{ width: '100%' }}
        />
      )}
      {audioName && (
        <Typography variant="caption" sx={{ display: 'block', mt: 1, color: '#6b6b6b' }}>
          {audioName}
        </Typography>
      )}
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button
        variant="text"
        onClick={onReRecord}
        sx={{ textTransform: 'none' }}
      >
        {reRecordLabel}
      </Button>
      <Button
        variant="outlined"
        onClick={onClose}
        sx={{ textTransform: 'none' }}
      >
        {cancelLabel}
      </Button>
      <Button
        variant="contained"
        onClick={onUpload}
        sx={{ textTransform: 'none' }}
        disabled={uploadDisabled}
      >
        {uploadLabel}
      </Button>
    </DialogActions>
  </Dialog>
);

export default AudioReviewDialog;
